<template>
  <div class="app-content">
    <div v-if="showContent">
      <new-message-button/>
      <div class="container">
        <div class="row">
          <div class="col-4 feed-column">
            <message-feed/>
          </div>
          <div class="col-8 content-column">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="container">
      <div class="app-content d-flex align-items-center justify-content-center">
        <div class="row col-md-8 justify-content-center text-center">
          <p>
            Es tut uns leid, beim Öffnen der Nachrichten ist etwas schiefgegangen!
            <br><br>
            Die angeforderte Pinnwand existiert nicht, oder Sie haben keine Berechtigung, sie zu öffnen.
            <br>
            Bitte loggen Sie sich aus der Klassenpinnwand aus und versuchen es nach einem späteren Login erneut.
            <br>
            Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an unseren
            <a href="mailto:support@klassenpinnwand.at" class="link-teacher-green"><b>Support</b></a>.
            <br><br>
            <div class="col-12 text-center mt-4">
              <a :href="klassenpinnwandUrl" class="btn-gradient btn-rounded" style="font-size: 18px;">
                <span class="px-5">Zurück zur Klassenpinnwand</span>
              </a>
            </div>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewMessageButton from '@/components/Messages/New/NewMessageButton';
import MessageFeed from '@/components/Messages/Feed/Index';

export default {
  name: 'Home',
  components: { NewMessageButton, MessageFeed },
  data() {
    return {
      showContent: true,
    };
  },
  computed: {
    klassenpinnwandUrl() {
      return process.env.KLASSENPINNWAND_URL;
    },
  },
  mounted() {
    this.$bus.$on('pinboard-not-found', () => {
      this.showContent = false;
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Home/Index.vue